import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import { getUrlWithStickyParams } from '../../util';
import { withRouteData } from 'react-static';

class CtaButton extends PureComponent {
  state = {
    link: this.props.link || '',
  };

  componentDidMount() {
    if (this.state.link) {
      const urlWithInAppParam = getUrlWithStickyParams(this.state.link, this.props.basename);
      // eslint-disable-next-line
      this.setState({ link: urlWithInAppParam });
    }
  }

  onButtonClick = e => {
    if (typeof document !== 'undefined' && window.analytics) {
      analytics.track('Clicked CTA Button', this.props.trackingData);
    }
    this.scrollToSamePageAnchor(e);
  };

  render() {
    return (
      <Button
        {...this.props}
        openInNewTab={this.props.openInNewTab}
        link={this.state.link}
        onClick={this.onButtonClick}
      />
    );
  }

  scrollToSamePageAnchor = e => {
    const { link } = this.state;
    if (!link || typeof window === 'undefined') {
      return;
    }

    try {
      const target = new URL(link, window.location.href);
      const { location } = window;
      const normalizePath = path => path.replace(/\/+$/, '');
      const isSamePage =
        target.origin === location.origin &&
        normalizePath(target.pathname) === normalizePath(location.pathname);

      if (!isSamePage || !target.hash) {
        return;
      }

      const id = decodeURIComponent(target.hash.slice(1));
      const el = document.getElementById(id);
      if (!el) {
        return;
      }

      e.preventDefault();
      el.scrollIntoView({ behavior: 'smooth' });
      if (window.history && window.history.pushState) {
        window.history.pushState(null, '', target.hash);
      }
    } catch (err) {
      // fall back to default anchor behaviour
    }
  };
}

CtaButton.propTypes = {
  trackingData: PropTypes.object.isRequired,
  openInNewTab: PropTypes.bool,
  link: PropTypes.string,
  basename: PropTypes.string.isRequired,
};

export default withRouteData(CtaButton);



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/common/CtaButton.js